import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom'
import { error as logError } from '../logger';
import { unsubscribeEmail as userUnsubscribeEmail } from '../dataProvider/user'

function UnsubscribeEmail() {

    const { t } = useTranslation();
    const { email } = useParams();

    useEffect(() => {
        async function handleUnsubscribe(){
            try {
                userUnsubscribeEmail(email)
            } catch(error) {
                logError(error)
            }
        }
        if(email) handleUnsubscribe()
    }, [email])

    return (
        <div className="unsubscribe-email">
            <div className="container my-5" dangerouslySetInnerHTML={{ __html: t('unsubscribeEmail.message') }} />
        </div>
    )

}

export default UnsubscribeEmail